import { createTicket } from "library/api/zendesk/zendesk";
import { getIsProduction } from "library/browser";
import { GetRequestLetterParams } from "../../components/RequestLetter/types";
import {
  nzLetters,
  nzProducts,
  requestLetterCustomFieldsAu,
  requestLetterCustomFieldsNZ,
} from "./customFieldsMap/requestLetterCustomFieldsMap";
import { formatDate } from "./zendeskAPI";

const GROUP_ID_AU = { prod: 360002312898, nonProd: 360004390118 };
const GROUP_ID_NZ = { prod: 360002369658, nonProd: 360004390538 };

const FORM_ID_AU = { prod: 360000124417, nonProd: 360000242718 };
const FORM_ID_NZ = { prod: 360000132757, nonProd: 360000233677 };

export async function createRequestLetterTicket({
  userName,
  email,
  token,
  isNZ,
  ...fields
}: GetRequestLetterParams) {
  const isProduction = getIsProduction();
  const envKey = isProduction ? "prod" : "nonProd";
  const productValue = isNZ
    ? nzProducts[fields.productName]?.[envKey] ?? ""
    : "product_type_credit_card";

  const ticketResponse = await createTicket(
    {
      isNZ,
      requester: {
        name: userName,
        email,
      },
      ticketFormId: isNZ ? FORM_ID_NZ[envKey] : FORM_ID_AU[envKey],
      groupId: isNZ ? GROUP_ID_NZ[envKey] : GROUP_ID_AU[envKey],
      subject: "Request letter",
      comment:
        "Request letter originating from the Latitude Service Centre (LSC).",
      customFields: [
        {
          id: requestLetterCustomFieldsAu["Customers first name"],
          value: fields.firstName,
        },
        {
          id: requestLetterCustomFieldsAu["Surname  (as it appears on ID)"],
          value: fields.lastName,
        },
        {
          id: requestLetterCustomFieldsAu.DOB,
          value: formatDate(fields.dateOfBirth),
        },
        {
          id: requestLetterCustomFieldsAu["Mobile Number"],
          value: fields.mobileNumber,
        },
        {
          id: requestLetterCustomFieldsAu["Relationship to account"],
          value: "account_holder",
        },
        {
          id: requestLetterCustomFieldsAu["Last 4 digits"],
          value: fields.last4digits,
        },
        {
          id: isNZ
            ? requestLetterCustomFieldsNZ["Letters - NZ/GEM"]
            : requestLetterCustomFieldsAu.Letters,
          value: nzLetters[fields.letterType][envKey],
        },
        {
          id: requestLetterCustomFieldsAu["Privacy Acknowledgement"],
          value: true,
        },
        {
          id: isNZ
            ? requestLetterCustomFieldsNZ["NZ Products"]
            : requestLetterCustomFieldsAu.Product,
          value: productValue,
        },
      ],
    },
    token,
  );

  return ticketResponse.data.ticket_id;
}
